var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgCake = function SvgCake(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 414.213,
    height: 550.328,
    viewBox: "0 0 414.213 550.328",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cake",
    transform: "translate(-27.561 65.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1460",
    "data-name": "Group 1460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1459",
    "data-name": "Group 1459"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M234.56,143a57.684,57.684,0,0,1-49.449-87.357L234.56-30l49.577,85.855A57.682,57.682,0,0,1,234.56,143Zm0-113-23.6,40.865a27.669,27.669,0,1,0,47.322.216Z",
    transform: "translate(0 -36)",
    fill: "#22282F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M198.226,134.333h72.667V177H362.56c43.416,0,78.95,35.4,79.213,78.91v32.836A56.785,56.785,0,0,1,344.806,328.9l-34.953-34.871-35.059,34.9a57.776,57.776,0,0,1-80.281-.025l-34.94-34.858-35.059,34.978A56.785,56.785,0,0,1,27.56,288.853V256a79.089,79.089,0,0,1,79-79h91.666Zm42.667,30H228.226V207H106.56a49.056,49.056,0,0,0-49,49v32.853a26.785,26.785,0,0,0,45.753,18.939l56.259-56.129,56.141,56.009a27.808,27.808,0,0,0,37.892.013l56.272-56.01,56.129,56a26.785,26.785,0,0,0,45.766-18.927V256a49.4,49.4,0,0,0-49.213-49H240.893Z",
    transform: "translate(0 -13)",
    fill: "#22282F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M309.679,296.891l33.515,33.515a58.45,58.45,0,0,0,74.868,6.78l23.5-16.154V448a36.374,36.374,0,0,1-36.333,36.333H63.893A36.374,36.374,0,0,1,27.56,448V321.03l23.5,16.155a58.63,58.63,0,0,0,33.315,10.481,57.436,57.436,0,0,0,41.259-17.178l33.752-33.6L192.9,330.406c10.478,10.478,25.623,16.487,41.554,16.487s31.076-6.009,41.553-16.487Zm-75.225,80c-23.827,0-46.705-9.212-62.767-25.273l-12.352-12.351L146.9,351.644a88.06,88.06,0,0,1-89.342,21.83V448a6.418,6.418,0,0,0,6.333,6.333H405.226A6.418,6.418,0,0,0,411.559,448V373.475a88.428,88.428,0,0,1-89.579-21.856l-12.351-12.351L297.2,351.644C281.159,367.681,258.281,376.893,234.454,376.893Z",
    fill: "#22282F"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgCake);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Cake.30763fd847aa0343984540128e9700ea.svg";